// Module
var code = `<div class="high-low-panel">

    <div class="high-low-panel-toolbar" name="ToolBar" style="display: {{showToolbar ? 'flex' : 'none'}};">

        <terceraInstrumentLookup name="SymbolsList"/>

        <terceraMultiComboBox name="ExchangeFilter"
            showLastValue="true" 
            on-ValueChange="exchangeFilterChanged"/>
    </div>

    <div class="high-low-panel-table-sector">
        <div class="high-low-tables-captions">
            <div class="low-table-caption">
                {{LowsTableCaption}}
            </div>
            <div class="high-table-caption">
                {{HighsTableCaption}}
            </div>
        </div>
        <div class="high-low-tables">
            <terceraPanel name='windowPanelBodyQT' />
        </div>

        <div class="HighLowTable-noDataContainer">
            <div class="HighLowTable-noData {{noDataForLows ? 'has-no-data' : ''}}">
                {{#if noDataForLows && showNoDataIcon}}
                    <div class="HighLowTable-noDataInfoIcon">
                        <svg>
                            <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#highLowList"></use>
                        </svg>
                    </div>
                    <div class="HighLowTable-noDataText">{{noDataText}}</div>
                {{/if}}
            </div>
            <div class="HighLowTable-noData {{noDataForHighs ? 'has-no-data' : ''}}">
                {{#if noDataForHighs && showNoDataIcon}}
                    <div class="HighLowTable-noDataInfoIcon">
                        <svg>
                            <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#highLowList"></use>
                        </svg>
                    </div>
                    <div class="HighLowTable-noDataText">{{noDataText}}</div>
                {{/if}}
            </div>
        </div>
    </div>

    
</div>`;
// Exports
export default code;